(function () {
  'use strict';

  var TYPE_PARAM = 'type';
  var VALID_TYPES = ['board', 'cake', 'catering', 'flowers'];

  function normalizeType(value) {
    if (!value) return 'board';
    var v = String(value).toLowerCase();
    return VALID_TYPES.indexOf(v) >= 0 ? v : 'board';
  }

  function setControlsDisabled(container, disabled) {
    if (!container) return;
    container.querySelectorAll('input, select, textarea, button').forEach(function (el) {
      el.disabled = disabled;
    });
  }

  function syncPanels(section, typeValue) {
    var panels = section.querySelectorAll('[data-fw-oa-type]');
    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-fw-oa-type') === typeValue;
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
      setControlsDisabled(panel, !isActive);
    });
  }

  function updateTypeInUrl(typeValue) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set(TYPE_PARAM, typeValue);
      window.history.replaceState(null, '', url);
    } catch (e) {
      /* noop */
    }
  }

  function applyProductType(section, typeValue, updateUrl) {
    var typeSelect = section.querySelector('.fw-oa__type');
    if (!typeSelect) return;
    var normalized = normalizeType(typeValue);
    typeSelect.value = normalized;
    syncPanels(section, normalized);
    if (updateUrl) {
      updateTypeInUrl(normalized);
    }
  }

  function closeHeaderNavPanels() {
    document.querySelectorAll('[data-fw-nav-panel]').forEach(function (panel) {
      panel.setAttribute('hidden', '');
    });
    document.querySelectorAll('[data-fw-nav-trigger]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function scrollToBuilder(section) {
    var target = section || document.getElementById('fw-oa-builder');
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function initHeaderOrderLinks(section) {
    if (!document.body.classList.contains('template-fw-order-ahead')) return;

    document.querySelectorAll('[data-fw-oa-nav-type]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var type = link.getAttribute('data-fw-oa-nav-type');
        if (!type) return;

        var href = link.getAttribute('href') || '';
        try {
          var destination = new URL(href, window.location.origin);
          if (destination.pathname !== window.location.pathname) return;

          event.preventDefault();
          applyProductType(section, type, true);
          closeHeaderNavPanels();
          scrollToBuilder(section);
        } catch (err) {
          /* allow normal navigation */
        }
      });
    });
  }

  function syncMessageCount(input) {
    var field = input.closest('.fw-oa__message-field');
    if (!field) return;
    var counter = field.querySelector('.fw-oa__message-count');
    if (!counter) return;
    var max = input.maxLength > 0 ? input.maxLength : 40;
    counter.textContent = String(input.value.length) + '/' + String(max);
  }

  function initSection(section) {
    var typeSelect = section.querySelector('.fw-oa__type');
    if (typeSelect) {
      var fromUrl = normalizeType(new URLSearchParams(window.location.search).get(TYPE_PARAM));
      applyProductType(section, fromUrl, Boolean(new URLSearchParams(window.location.search).get(TYPE_PARAM)));

      typeSelect.addEventListener('change', function () {
        applyProductType(section, typeSelect.value, true);
      });
    }

    section.querySelectorAll('.fw-oa__message').forEach(function (input) {
      syncMessageCount(input);
      input.addEventListener('input', function () {
        syncMessageCount(input);
      });
    });

    initHeaderOrderLinks(section);
  }

  function init() {
    document.querySelectorAll('.fw-oa').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
